// Creates the Android "Coach messages" channel once per app launch.
// iOS time-sensitive delivery is an entitlement plus the APNs payload.
// This is a no-op on web and iOS.

import { Capacitor } from "@capacitor/core";
import { coachDmChannelCreateArgs } from "@shared/coachDmChannel";

let pending: Promise<void> | null = null;

export function ensureCoachDmNotificationChannel(): Promise<void> {
  if (pending) return pending;
  pending = createCoachDmChannel();
  return pending;
}

async function createCoachDmChannel(): Promise<void> {
  try {
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android") return;
    const { PushNotifications } = await import("@capacitor/push-notifications");
    await PushNotifications.createChannel(coachDmChannelCreateArgs());
  } catch (err) {
    pending = null;
    console.warn("[Push] Coach message channel was not created:", err);
  }
}
